import React, { useState, useEffect } from "react";
import { ethers } from "ethers";
import tokenList from "../tokenList.json";

const nativeTokenSymbols = {
    1: 'ETH',
    1313161554: 'ETH',
    42161: 'ETH',
    43114: 'AVAX',
    8453: 'ETH',
    56: 'BNB',
    250: 'FTM',
    100: 'xDAI',
    8217: 'KLAY',
    10: 'ETH',
    137: 'MATIC',
    324: 'ETH',
};

function TokenBalances({ address, isConnected }) {
    const [provider, setProvider] = useState(null);
    const [balances, setBalances] = useState({});
    const [chainId, setChainId] = useState(null);

    useEffect(() => {
        const setupProvider = async () => {
            if (window.ethereum && isConnected) {
                const newProvider = new ethers.providers.Web3Provider(window.ethereum);
                setProvider(newProvider);

                // Retrieve the network and chainId
                const network = await newProvider.getNetwork();
                setChainId(network.chainId);
            }
        };
        setupProvider();
    }, [isConnected]);

    useEffect(() => {
        const getTokenBalances = async () => {
            if (!provider || !address || chainId === null) return;

            const newBalances = {};
            const tokens = tokenList[chainId.toString()];

            if (!tokens) {
                console.error(`No tokens found for chainId ${chainId}`);
                return;
            }

            for (let token of tokens) {
                let balance;
                try {
                    if (token.address === '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee') {
                        // Fetch balance of the native token
                        balance = await provider.getBalance(address);
                        balance = ethers.utils.formatEther(balance);
                    } else {
                        // Fetch balance of ERC-20 token
                        const tokenContract = new ethers.Contract(token.address, [
                            {
                                "constant": true,
                                "inputs": [{ "name": "_owner", "type": "address" }],
                                "name": "balanceOf",
                                "outputs": [{ "name": "balance", "type": "uint256" }],
                                "payable": false,
                                "type": "function"
                            },
                            {
                                "constant": true,
                                "inputs": [],
                                "name": "decimals",
                                "outputs": [{ "name": "", "type": "uint8" }],
                                "payable": false,
                                "type": "function"
                            }
                        ], provider);
                        balance = await tokenContract.balanceOf(address);
                        const decimals = await tokenContract.decimals();
                        balance = ethers.utils.formatUnits(balance, decimals);
                    }
                } catch (error) {
                    console.error(`Failed to fetch balance for ${token.name}:`, error);
                    balance = 'Error';
                }
                newBalances[token.ticker] = balance;
                console.log(`Fetched balance for ${token.ticker}: ${balance}`);
            }

            // Fetch balance for native token if not in the token list
            if (!tokens.some(token => token.address === '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')) {
                const nativeBalance = await provider.getBalance(address);
                newBalances[nativeTokenSymbols[chainId]] = ethers.utils.formatEther(nativeBalance);
                console.log(`Fetched balance for native token (${nativeTokenSymbols[chainId]}): ${newBalances[nativeTokenSymbols[chainId]]}`);
            }

            setBalances(newBalances);
            console.log("Updated balances:", newBalances);
        };

        if (provider && address && chainId !== null) {
            getTokenBalances();
        }
    }, [provider, address, chainId]);

    return (
        <div>
            <h2>Token Balances</h2>
            {address ? (
                <div>
                    <p>Fetching token balances for: {address}</p>
                    <ul>
                        {chainId !== null && tokenList[chainId.toString()] ? tokenList[chainId.toString()].map((token) => (
                            <li key={token.ticker}>
                                {token.ticker}: {balances[token.ticker] !== undefined ? balances[token.ticker] : 'Loading...'}
                            </li>
                        )) : <p>No tokens available for the selected network.</p>}
                        {balances[nativeTokenSymbols[chainId]] !== undefined && (
                            <li key={nativeTokenSymbols[chainId]}>
                                {nativeTokenSymbols[chainId]}: {balances[nativeTokenSymbols[chainId]]}
                            </li>
                        )}
                    </ul>
                </div>
            ) : (
                <p>Connect your wallet to see token balances</p>
            )}
        </div>
    );
}

export default TokenBalances;
